<template>
  <div id="container">
    <out-an-invoice-information ref="outAnInvoiceInformationRefs"></out-an-invoice-information>
    <!--------------------------------------- 开票清单 -------------------------------------->
    <div class="item-box-content">
      <div class="title-font-style">
        <span>开票清单</span>
      </div>
      <el-row :gutter="20">
        <!--------------------------------------- 待开票产品 -------------------------------------->
        <el-col :span="12">
          <div class="join-remove-sell">
            <div class="table-title">待开票产品</div>
            <div class="totals"></div>
            <el-table
              border
              :data="productList"
              :header-cell-style="tableHeader"
              empty-text="产品已全部移入开票区！"
              v-loading="loadingProTable"
              height="430px"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
              @selection-change="handleSelectionImm"
              @row-dblclick="dblclickL"
            >
              <el-table-column fixed type="selection" width="35"></el-table-column>
              <el-table-column prop="proName" label="产品名称" min-width="100" show-overflow-tooltip></el-table-column>
              <el-table-column prop="proType" label="型号" show-overflow-tooltip min-width="80"></el-table-column>
              <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip min-width="100"></el-table-column>
              <el-table-column label="销售单价" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.cbPrice|priceFilterNum}}</template>
              </el-table-column>
              <el-table-column label="备货状态">
                <template slot-scope="scope">{{scope.row.stockupState|stockupStateFilter}}</template>
              </el-table-column>
              <el-table-column label="发货状态">
                <template slot-scope="scope">{{scope.row.deliverState|deliverStateFilter}}</template>
              </el-table-column>
              <el-table-column prop="notInvoice" label="数量" width="80"></el-table-column>
            </el-table>
            <el-col :span="24" class="join-remove-sell-btn">
              <el-button type="primary" @click="immigrateAll">全部移入</el-button>
              <el-button type="primary" @click="immigrate" plain>移入开票区</el-button>
            </el-col>
          </div>
        </el-col>
        <!--------------------------------------- 开票区 -------------------------------------->
        <el-col :span="12">
          <div class="join-remove-sell">
            <div class="table-title">开票区</div>
            <div class="totals">开票总额：{{ totals|priceFilterNum }}</div>
            <el-table
              border
              :data="repAvacList"
              :header-cell-style="tableHeader"
              height="430px"
              element-loading-spinner="el-icon-loading"
              @selection-change="handleSelectionRe"
              @row-dblclick="dblclickR"
              empty-text="请选择开票产品！"
            >
              <el-table-column fixed type="selection" width="35"></el-table-column>
              <el-table-column prop="proName" label="产品名称" min-width="100" show-overflow-tooltip></el-table-column>
              <el-table-column prop="proType" label="型号" show-overflow-tooltip min-width="80"></el-table-column>
              <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip min-width="90"></el-table-column>
              <el-table-column label="销售单价" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.cbPrice|priceFilterNum}}</template>
              </el-table-column>
              <el-table-column label="备货状态" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.stockupState|stockupStateFilter}}</template>
              </el-table-column>
              <el-table-column label="发货状态" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.deliverState|deliverStateFilter}}</template>
              </el-table-column>
              <el-table-column label="数量" width="125" fixed="right">
                <template slot-scope="scope">
                  <el-input-number
                    style="width:100%"
                    controls-position="right"
                    v-model="scope.row.notInvoice"
                    @change="handleNumber(scope.row)"
                    :min="0"
                    :max="scope.row.max"
                  ></el-input-number>
                </template>
              </el-table-column>
            </el-table>
            <el-col :span="24" class="join-remove-sell-btn">
              <el-button type="primary" @click="onRemoveAll">全部移出</el-button>
              <el-button type="primary" @click="onRemove" plain>移出开票区</el-button>
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-button @click="onApplyForMakeOutAnInvoice" type="primary">申请开票</el-button>
    <div
      style="margin-top:14px; color:#D35E5E"
    >开票时，优先开已备货已发货产品。开票清单中，若存在未发货产品，申请开票需要上级审核。开票审核通过后请及时联系处理人领取</div>
    <!-------------- 申请开票 确认 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      title="确认开票"
      :content="content"
    ></open-or-close>
    <open-or-close
      ref="OpenOrCloseRefs2"
      @onUpdataState="onUpdataState"
      title="确认开票"
      :content="content"
    ></open-or-close>
  </div>
</template>
<script>
import OpenOrClose from '@/components/OpenOrClose/index'
import outAnInvoiceInformation from './outAnInvoiceInformation.vue'
import {
  queryByNotInvoiceContent,
  orderContractInvoice,
  doYouNeedApproval
} from '@/api/sell/sellManage'
export default {
  components: {
    'out-an-invoice-information': outAnInvoiceInformation,
    'open-or-close': OpenOrClose
  },
  data() {
    return {
      params: {},
      queryParams: {},
      content: '', // 确认申请开票内容
      loadingProTable: false, // 产品清单列表区loding
      repAvacList: [], // 开票区 列表
      tempLise: [], // 开票区  选中列表
      productList: [], // 待开票产品 列表
      tempWaitLise: [], // 待开票产品 选中列表
      totals: 0, // 开票总额
      flag: true
    }
  },
  mounted() {
    this.getList()
  },
  watch: {
    repAvacList: {
      handler(val) {
        this.totals = 0
        val.forEach((ele) => {
          this.totals += ele.notInvoice * ele.cbPrice
        })
      },
      deep: true
    }
  },
  methods: {
    // 申请开票
    onApplyForMakeOutAnInvoice() {
      this.queryParams = this.$refs.outAnInvoiceInformationRefs.queryParams
      if (this.repAvacList.length < 1) {
        this.$message.error('请设置开票产品！')
        return
      }
      if (
        !this.queryParams.invoiceType ||
        !this.queryParams.isMeger ||
        !this.queryParams.ciTaxcode ||
        !this.queryParams.ciBankcode ||
        !this.queryParams.ciTaxaddress ||
        !this.queryParams.ciBank ||
        !this.queryParams.ciPhone
      ) {
        this.$message.error('请填写完整开票信息！')
        return
      }
      if (this.$refs.outAnInvoiceInformationRefs.isShow) {
        this.$message.error('请保存收票信息！')
        return
      }
      if (
        !this.queryParams.ciRecevierPhone ||
        !this.queryParams.ciRecevier ||
        !this.queryParams.ciRecevierProvince
      ) {
        this.$message.error('请填写收票信息！')
        return
      }
      Object.assign(this.queryParams, {
        isMergen: Number(this.queryParams.isMeger)
      })
      this.params = {
        bankOpen: this.queryParams.ciBank,
        invoicePhone: this.queryParams.ciPhone,
        bankNumber: this.queryParams.ciBankcode,
        cusName: this.queryParams.ciName,
        invoiceAddress: this.queryParams.ciTaxaddress,
        invoiceMark: this.queryParams.invoiceMark,
        amount: this.totals,
        bilingType: this.queryParams.bilingType,
        invoiceType: this.queryParams.invoiceType,
        isMeger: this.queryParams.isMeger,
        ocbId: this.$route.query.id,
        receiveAddress: this.queryParams.ciRecevierAddress,
        receivePeople: this.queryParams.ciRecevier,
        receivePhone: this.queryParams.ciRecevierPhone,
        receiveProcode: this.queryParams.ciRecevierProcode,
        receiveProvince: this.queryParams.ciRecevierProvince,
        taxNumber: this.queryParams.ciTaxcode,
        orderContractInvoiceContentList: []
      }
      this.params.orderContractInvoiceContentList = JSON.parse(
        JSON.stringify(this.repAvacList)
      )
      this.params.orderContractInvoiceContentList.forEach((item) => {
        item.quantity = item.notInvoice
      })
      doYouNeedApproval(this.params).then((res) => {
        if (res.data.code === 200) {
          this.flag = res.data.obj
          this.content = this.flag ? '开票申请发起后不可撤回，是否确认开票？' : '当前开票清单中存在不满足开票产品，确认后将由上级审核。'
        }
        this.$refs.OpenOrCloseRefs.onInitial()
      })
    },
    // 二次确认弹窗
    onUpdataState() {
      orderContractInvoice(this.flag, this.params).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('已申请开票，请等待审核！')
          this.$router.push({
            name: 'contractEdit',
            query: {
              id: this.$route.query.id,
              cusId: this.$route.query.cusId
            }
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getList() {
      queryByNotInvoiceContent(
        this.$route.query.id,
        this.$route.query.cusId
      ).then((res) => {
        if (res.data.code === 200) {
          res.data.obj.orderContractNotInvoiceVoList.forEach((ele) => {
            ele.max = ele.notInvoice
            ele.ocbId = ele.occId
          })
          this.productList = res.data.obj.orderContractNotInvoiceVoList
          const obj = {
            contractCode: res.data.obj.contractCode,
            customerContractCode: res.data.obj.customerContractCode,
            invocieAmountLimit: res.data.obj.invocieAmountLimit,
            bilingType: '销售货款',
            ...res.data.obj.customerInvoice
          }
          this.$refs.outAnInvoiceInformationRefs.init(obj)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // -------------------   产品清单   ----------------
    onRemoveAll() {
      // 全部移出
      this.tempLise = JSON.parse(JSON.stringify(this.repAvacList))
      this.onRemove()
    },
    dblclickR(row) {
      this.tempLise = [row]
      this.onRemove()
    },
    onRemove() {
      if (this.tempLise.length === 0) {
        this.$message.error('请选中产品')
      } else {
        this.tempLise.forEach(m => {
          const i = this.productList.findIndex(n => n.ocId === m.ocId && n.stateSort === m.stateSort)
          m.notInvoice = m.max
          if (i === -1) {
            this.productList.push(m)
          } else {
            this.productList.splice(i, 1, m)
          }
          const int = this.repAvacList.findIndex(n => n.ocId === m.ocId && n.stateSort === m.stateSort)
          this.repAvacList.splice(int, 1)
        })
        this.tempLise = []
      }
    },
    handleSelectionRe(val) {
      this.tempLise = val
    },
    handleNumber(row) {
      // 计数器加减
      if (!row.notInvoice) {
        this.dblclickR(row)
        return
      }
      row.notInvoice = Math.floor(row.notInvoice)
      const num = row.max - row.notInvoice
      console.log(row, num)
      if (num === 0) {
        this.productList.forEach((ele, index) => {
          if (ele.ocId === row.ocId && ele.stateSort === row.stateSort) {
            this.productList.splice(index, 1)
          }
        })
      } else {
        let isParam = false
        for (let i = 0; i < this.productList.length; i++) {
          if (
            this.productList[i].ocId === row.ocId &&
            this.productList[i].stateSort === row.stateSort
          ) {
            isParam = true
            this.productList[i].notInvoice = num
          }
        }
        if (!isParam) {
          const params = JSON.parse(JSON.stringify(row))
          params.notInvoice = num
          this.productList.push(params)
        }
      }
    },
    handleSelectionImm(val) {
      this.tempWaitLise = val
    },
    immigrate() {
      if (this.tempWaitLise.length === 0) {
        this.$message.error('请选中产品')
      } else {
        this.tempWaitLise.forEach(m => {
          const i = this.repAvacList.findIndex(n => n.ocId === m.ocId && n.stateSort === m.stateSort)
          m.notInvoice = m.max
          if (i === -1) {
            this.repAvacList.push(m)
          } else {
            this.repAvacList.splice(i, 1, m)
          }
          const int = this.productList.findIndex(n => n.ocId === m.ocId && n.stateSort === m.stateSort)
          this.productList.splice(int, 1)
        })
        this.tempWaitLise = []
      }
    },
    dblclickL(row) {
      this.tempWaitLise = [row]
      this.immigrate()
    },
    immigrateAll() {
      // 全部移入
      this.tempWaitLise = JSON.parse(JSON.stringify(this.productList))
      this.immigrate()
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.totals {
  margin-bottom: 10px;
  padding-right: 20px;
  height: 21px;
  text-align: right;
  font-size: 12px;
  font-weight: 500;
  color: #276cff;
  line-height: 21px;
}
</style>
